/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { SvgInfoAdminControllerService } from './services/svg-info-admin-controller.service';
import { SvgInfoControllerService } from './services/svg-info-controller.service';
import { SvgInfoAdminSecurityExpertControllerService } from './services/svg-info-admin-security-expert-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    SvgInfoAdminControllerService,
    SvgInfoControllerService,
    SvgInfoAdminSecurityExpertControllerService,
    ApiConfiguration
  ],
})
export class CustomersSvginfoModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersSvginfoModule> {
    return {
      ngModule: CustomersSvginfoModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersSvginfoModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersSvginfoModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
